<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div><strong>{{ snackbar.title }}</strong></div>
              <div style="white-space: pre-line;">{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <v-card class="mx-auto pa-4" elevation="2">
      <v-card-title class="d-flex align-center py-2">
        <v-avatar color="primary" size="36" class="elevation-1 mr-3">
          <v-icon dark size="20">mdi-cog-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-h6 font-weight-bold primary--text">
            User Management System
          </div>
          <div class="text-caption grey--text text--darken-1">
            Configure and oversee all user accounts
          </div>
        </div>
      </v-card-title>
      <v-card flat>
            <v-card-text class="pt-2">
                  <v-card outlined>
                    <v-card-title class="flex-wrap" style="gap: 8px;">
                      <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
                      User List
                      <v-spacer></v-spacer>
                      <v-btn small color="#2d7c44" dark @click="showRegisterDialog = true">
                        <v-icon left small>mdi-account-plus</v-icon>
                        Add New User
                      </v-btn>
                      <v-btn small outlined color="#FF5722" @click="UploadDialog = true">
                        <v-icon left small>mdi-file-excel</v-icon>
                        Import Users
                      </v-btn>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        outlined
                        dense
                        class="search-field"
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                      :headers="headers"
                      :items="datas"
                      :search="search"
                      class="elevation-1"
                      style="min-width: 900px; width: 100%"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, -1],
                        'items-per-page-text': 'Page:'
                      }"
                      >
                      <template #[`item.name`]="{ item }">
                        <div class="d-flex align-center">
                          <v-avatar size="28" color="grey lighten-3" class="mr-2 flex-shrink-0">
                            <v-img v-if="item.image" :src="`${baseURL}/storage/${item.image}`" />
                            <v-icon v-else small color="grey">mdi-account</v-icon>
                          </v-avatar>
                          {{ item.name }}
                        </div>
                      </template>
                      <template #[`item.role`]="{ item }">
                        <v-chip
                          x-small
                          label
                          :color="roleChip(item.role).color"
                          :text-color="roleChip(item.role).textColor"
                          class="font-weight-medium"
                        >
                          <v-icon left x-small :color="roleChip(item.role).textColor">
                            {{ roleChip(item.role).icon }}
                          </v-icon>
                          {{ roleChip(item.role).label }}
                        </v-chip>
                      </template>
                      <template #[`item.last_login_at`]="{ item }">
                        {{ formatLastLogin(item.last_login_at) }}
                      </template>
                      <template #[`item.entity_name`]="{ item }">
                        {{ item.entity_name }}
                      </template>
                       <template #[`item.phone_entity`]="{ item }">
                        {{ item.phone_entity }}
                      </template>
                       <template #[`item.address_entity`]="{ item }">
                        {{ item.address_entity }}
                      </template>
                      <template #[`item.status`]="{ item }">
                        <v-chip
                          :color="getStatusColor(item.status)"
                          dark
                          small
                        >
                          {{ item.status }}
                        </v-chip>
                      </template>
                      <template #[`item.actions`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              @click="editItem(item)"
                            >
                              <v-icon size="20">mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit User</span>
                        </v-tooltip>
                         <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="orange"
                              v-bind="attrs"
                              v-on="on"
                              @click="reset(item)"
                              >
                              <v-icon size="20">mdi-lock-reset</v-icon>
                            </v-btn>
                          </template>
                          <span>Reset Password User</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="error"
                              v-bind="attrs"
                              v-on="on"
                              @click="showStatusDialog(item)"
                              
                            >
                              <v-icon size="20">mdi-account-off</v-icon>
                            </v-btn>
                          </template>
                          <span>Setting Status Kpi</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="error"
                              v-bind="attrs"
                              v-on="on"
                              @click="deleteItem(item)"
                            >
                              <v-icon size="20">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete User</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card>
            </v-card-text>
          </v-card>
      <v-dialog v-model="editDialog" max-width="650px" persistent>
        <v-card>
          <v-toolbar color="#125a97" dark>
            <v-toolbar-title>Edit User</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeEdit">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="editedItem.name" 
                    label="Username"
                    prepend-icon="mdi-account"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="editedItem.entity_name" 
                    label="Entity Name"
                    prepend-icon="mdi-card-account-details"
                    outlined
                    dense
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="editedItem.email" 
                    label="Email"
                    prepend-icon="mdi-email"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="editedItem.phone" 
                    label="Phone"
                    prepend-icon="mdi-phone"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                  <v-col cols="12" sm="6">
                 <v-select
                  v-model="editedItem.role"
                  label="Role"
                  :items="availableRoles"
                  prepend-icon="mdi-shield-account"
                  outlined
                  dense
                ></v-select>
                  </v-col>
                <v-col cols="12" sm="6">
                 <v-file-input
                      v-model="editedItem.profile_img"
                      label="Profile Image"
                      prepend-icon="mdi-camera"
                      outlined
                      accept="image/*"
                      show-size
                      dense
                    ></v-file-input>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeEdit">
              <v-icon left>mdi-cancel</v-icon>
              Cancel
            </v-btn>
            <v-btn color="success" @click="saveEdit">
              <v-icon left>mdi-content-save</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-dialog v-model="resetpassDialog" max-width="400px">
        <v-card>
            <v-toolbar color="orange" dark>
            <v-toolbar-title>Reset Password User</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeEdit">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title class="headline error--text">
            <v-icon left color="error">mdi-alert-circle</v-icon>
            Confirm Reset !
          </v-card-title>
          <v-card-text class="pa-4">
            Are you sure you want to reset password this user? This action cannot be undone.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="error" text @click="closeEdit">
              <v-icon left>mdi-cancel</v-icon>
              Cancel
            </v-btn>
            <v-btn color="error" @click="ResetPassword">
              <v-icon left>mdi-lock-open</v-icon>
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="resetInfoDialog" max-width="460px">
        <v-card>
          <v-toolbar color="success" dark dense flat>
            <v-toolbar-title>{{ resetInfoTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="resetInfoDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <div class="mb-2 text-caption grey--text text--darken-1">
              Salin dan kirimkan informasi login berikut ke user:
            </div>
            <v-textarea
              v-model="resetInfoText"
              readonly
              outlined
              hide-details
              auto-grow
              style="font-family: monospace; font-size: 13px;"
            />
          </v-card-text>
          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="copyResetInfo">
              <v-icon left small>mdi-content-copy</v-icon>
              Copy
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="UploadDialog" max-width="520" persistent content-class="rounded-xl">
        <v-card class="rounded-xl">
          <v-card-title class="py-3 px-5">
            <v-icon color="#FF5722" class="mr-2">mdi-file-excel</v-icon>
            <span class="text-subtitle-1 font-weight-bold">Import Users</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="closeUploadDialog">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text class="px-5 py-4">
            <div class="d-flex align-center mb-4">
              <v-avatar size="30" color="blue lighten-5" class="mr-3">
                <span class="primary--text font-weight-bold">1</span>
              </v-avatar>
              <div class="flex-grow-1 mr-3">
                <div class="text-body-2 font-weight-medium">Download template</div>
                <div class="text-caption grey--text">File XLSX dengan kolom yang dibutuhkan</div>
              </div>
              <v-btn
                small
                outlined
                color="primary"
                :loading="downloadingTemplate"
                @click="downloadTemplate"
              >
                <v-icon left small>mdi-download</v-icon>
                Template
              </v-btn>
            </div>

            <div class="d-flex align-start">
              <v-avatar size="30" color="green lighten-5" class="mr-3">
                <span class="success--text font-weight-bold">2</span>
              </v-avatar>
              <div class="flex-grow-1">
                <div class="text-body-2 font-weight-medium mb-2">Upload template yang sudah diisi</div>
                <v-file-input
                  v-model="excelFile"
                  accept=".xlsx, .xls"
                  placeholder="Pilih file Excel…"
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                  outlined
                  dense
                  hide-details
                  @change="onExcelSelected"
                ></v-file-input>
              </div>
            </div>
            <v-expand-transition>
              <div v-if="uploadResult" class="mt-4">
                <v-alert
                  :type="uploadResult.ok ? 'success' : 'error'"
                  rounded="lg"
                  class="mb-4"
                >
                  {{ uploadResult.message }}
                </v-alert>

                <div v-if="uploadResult.failures && uploadResult.failures.length">
                  <div
                    v-for="(f, idx) in uploadResult.failures"
                    :key="idx"
                    class="d-flex align-start py-2"
                    :class="{ 'upload-failure-divider': idx > 0 }"
                  >
                    <v-chip x-small label color="red lighten-5" text-color="red darken-2" class="mr-3 mt-1 flex-shrink-0">
                      <!-- f.row = nomor baris Excel (baris 1 = header) -->
                      Baris {{ f.row - 1 }}
                    </v-chip>
                    <div class="text-body-2">
                      {{ (Array.isArray(f.errors) ? f.errors : [f.errors]).join(' ') }}
                      <div v-if="f.values?.name || f.values?.email" class="text-caption grey--text">
                        {{ [f.values?.name, f.values?.email, f.values?.phone].filter(Boolean).join(' · ') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="px-5 py-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeUploadDialog">Tutup</v-btn>
            <v-btn
              small
              depressed
              color="success"
              :loading="uploadingExcel"
              :disabled="!excelFile"
              @click="uploadExcel"
            >
              <v-icon left small>mdi-cloud-upload</v-icon>
              Upload
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showRegisterDialog" max-width="800px" persistent>
        <v-card>
          <v-toolbar color="#2d7c44" dark>
            <v-toolbar-title>
              <v-icon left>mdi-account-plus</v-icon>
              Register New User
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showRegisterDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-chip
              small
              label
              color="blue-grey lighten-5"
              text-color="blue-grey darken-3"
              class="ml-3 mb-2 font-weight-medium"
            >
              <v-icon left small color="blue-grey darken-2">mdi-domain</v-icon>
              {{ entity?.name?.toUpperCase() }}
            </v-chip>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newUser.email"
                      label="Email"
                      prepend-icon="mdi-email"
                      outlined
                      required
                      type="email"
                      :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Email must be valid']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newUser.username"
                      label="Name"
                      prepend-icon="mdi-account-circle"
                      outlined
                      required
                      :rules="[v => !!v || 'Username is required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newUser.phone"
                      label="Phone Number"
                      prepend-icon="mdi-phone"
                      outlined
                      required
                      :rules="[v => !!v || 'Phone number is required']"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newUser.password"
                      label="Password"
                      prepend-icon="mdi-lock"
                      outlined
                      required
                      type="password"
                      hint="At least 8 characters with letters and numbers"
                      persistent-hint
                      :rules="[v => !!v || 'Password is required', v => v.length >= 8 || 'Password must be at least 8 characters']"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newUser.password_confirmation"
                      label="Confirm Password"
                      prepend-icon="mdi-lock-check"
                      outlined
                      required
                      type="password"
                      :rules="[v => !!v || 'Password confirmation is required', v => v === newUser.password || 'Passwords must match']"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      v-model="newUser.entity_id"
                      :items="entityOptions"
                      label="Entity"
                      prepend-icon="mdi-domain"
                      outlined
                      dense
                      item-text="text"
                      item-value="value"
                      :disabled="!isSuperAdmin"  
                    />
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6">
                    <v-select
                      v-model="newUser.status"
                      :items="['Active', 'Inactive']"
                      label="Status"
                      prepend-icon="mdi-check-circle"
                      outlined
                    ></v-select>
                  </v-col> -->
                   <v-col cols="12" sm="6" v-if="!isUser">
                    <v-select
                      v-model="newUser.role"
                      :items="availableRoles"
                      label="Role"
                      prepend-icon="mdi-shield-account"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="showRegisterDialog = false">
              <v-icon left>mdi-cancel</v-icon>
              Cancel
            </v-btn>
            <v-btn color="success" @click="registerUser" :disabled="!valid">
              <v-icon left>mdi-account-check</v-icon>
              Register User
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" max-width="400px">
        <v-card>
          <v-card-title class="headline error--text">
            <v-icon left color="error">mdi-alert-circle</v-icon>
            Confirm Delete
          </v-card-title>
          <v-card-text class="pa-4">
            Are you sure you want to delete this user? This action cannot be undone.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">
              Cancel
            </v-btn>
            <v-btn color="error" @click="confirmDelete">
              <v-icon left>mdi-delete</v-icon>
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="statusDialog" max-width="420" content-class="rounded-xl">
      <v-card flat class="glass-card pa-2">
        <v-card-title
          class="d-flex align-center white--text py-4 px-5 headline"
          style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 16px 16px 0 0;"
        >
          <v-icon left size="28" class="mr-2">mdi-publish</v-icon>
          Publish KPI
        </v-card-title>

        <v-card-text class="pa-6">
          <div v-if="selectedItem" class="text-center">
            <v-avatar size="100" class="elevation-3 mb-3">
              <v-img
                :src="selectedItem.profile_img_url || require('@/assets/hr.png')"
                alt="avatar"
              />
            </v-avatar>

            <div class="text-h6 font-weight-bold primary--text mb-1">
              {{ selectedItem.name }}
            </div>
            <div class="text-subtitle-2 grey--text mb-4">
              {{ selectedItem.email }}
            </div>

            <v-select
              v-model="selectedItem.status_publish"
              :items="[
                { text: '🟢 Published', value: 1 },
                { text: '🟠 Adjust Accounting', value: 2 },
                { text: '🔴 Unpublished', value: 0 }
              ]"
              label="Status Publish"
              outlined
              dense
              rounded
              class="mx-auto"
              style="max-width: 240px"
              hide-details
            />
          </div>
        </v-card-text>

        <v-divider class="mx-4" />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text rounded class="px-5" @click="statusDialog = false">
            Cancel
          </v-btn>
          <v-btn
            rounded
            dark
            class="px-6"
            color="success"
            @click="updateStatus(selectedItem)"
          >
            <v-icon left>mdi-check-circle</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'AdminSetup',
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      search: '',
      selectedItem: null,
      editDialog: false,
      deleteDialog: false,
      resetpassDialog: false,
      resetInfoDialog: false,
      resetInfoTitle: '',
      resetInfoText: '',
      statusDialog: false,
      UploadDialog: false,
      showRegisterDialog: false,
      downloadingTemplate: false,
      excelFile: null,
      uploadingExcel: false,
      uploadResult: null,
      valid: true,
      editedIndex: -1,
      Roles:'',
      roles: ['admin','user'],
      defaultItem: {
        username: '',
        fullname: '',
        email: '',
        phone: '',
        role: '',
        status: ''
      },
     editedItem: {
        id: '',
        name: '',            
        email: '',
        phone: '',
        entity_id: '',       
        entity_name: '',       
        profile_img: null,
        password: '',
        password_confirmation: '',
        status: 'Active',
        role: '',             
        entity_role: '',       
        permissions: []
      },
      newUser: {
        name: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        password_confirmation: '',
        status: 'Active',
        role: 'User',
        permissions: []
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phone' },
        { text: 'Role', value: 'role', width: '10%' },
        { text: 'Last Login', value: 'last_login_at' },
        { text: 'Actions', value: 'actions', sortable: false, width: '20%' }
      ],
      datas:[],
    }
  },

mounted() {
  this.waitForTokenAndLoad();
},

computed: {
  baseURL() {
    return process.env.VUE_APP_URL;
  },
  user() {
    return this.$store.state.user;
  },
  entity() {
    return this.$store.state.entity;
  },
  isUser() {
    return this.user?.role === 'user';
  },
  isAdmin() {
    return this.user?.role === 'admin';
  },
  isSuperAdmin() {
    return this.user?.role === 'super_admin';
  },
  availableRoles() {
    return this.isSuperAdmin ? ['user', 'admin', 'super_admin'] : ['user','admin'];
  },
  entityOptions() {
    return this.entity?.id
      ? [{ text: this.entity.name, value: this.entity.id }]
      : [];
  }
},
watch: {
  'entity.id': {
    async handler(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        await this.$nextTick();
        this.getUserlist();
      }
    },
    immediate: false
  }
},
methods: {
async waitForTokenAndLoad() {
    let retries = 5;
    while (!this.$store.getters.isTokenUser && retries-- > 0) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    if (!this.$store.getters.isTokenUser) return;
    if (this.user?.role === 'super_admin') {
      this.getUserlist(); 
      this.$root.$off('entity-updated');
      this.$root.$on('entity-updated', this.getUserlist);
    } else {
      this.getUserlistBySelfEntity();
    }
},

navigateToUsers() {
  this.showRegisterDialog = true;
},

getStatusColor(status) {
return status === 'Active' ? 'success' : 'error'
},

editItem(editedItem) {
  this.editedItem.id = editedItem.id;
  this.editedItem.name = editedItem.name;
  this.editedItem.email = editedItem.email;
  this.editedItem.phone = editedItem.phone;
  this.editedItem.role = editedItem.role;
  this.editedItem.entity_id = editedItem.entity?.id || '';
  this.editedItem.entity_name = editedItem.entity?.name || '-';
  this.editedItem.entity_role = editedItem.role;
  this.editDialog = true;
},

reset(editedItem) {
  this.editedItem.name = editedItem.name;
  this.editedItem.id = editedItem.id;
  this.editedItem.entity_name = editedItem.entity_name
  this.editedItem.email = editedItem.email
  this.editedItem.phone_entity = editedItem.phone_entity
  this.editedItem.entity_role = editedItem.entity_role
  this.resetpassDialog = true;

},

async saveEdit() {
  this.$store.dispatch('setOverlay', true);
    const formData = new FormData();
    formData.append('name',this.editedItem.name);
    formData.append('email',this.editedItem.email)
    formData.append('phone',this.editedItem.phone)
    formData.append('role',this.editedItem.role)
      if (this.editedItem.profile_img instanceof File) {
      formData.append('profile_img',this.editedItem.profile_img)
      }
     try {
         await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/user/${this.editedItem.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        this.$store.dispatch('setOverlay', false);
        this.EditDialog = false;
        await this.getUserlist();
        this.snackbar = {
          color: "success",
          icon: "mdi-check-circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          title: "Success",
          text: "Successfully Update User",
          visible: true
        };
      } catch (err) {
        this.$store.dispatch('setOverlay', false);
        this.snackbar = {
          color: "error",
          icon: "mdi-alert-circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          title: "Error",
          text: err.response?.data?.message || 'Failed to Reset Users !',
          visible: true
        };
      }
      this.closeEdit()
},

async ResetPassword() {
  this.$store.dispatch('setOverlay', true);
     try {
        
         const res = await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/users/reset-password/${this.editedItem.id}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`
            }
          }
        );
        this.$store.dispatch('setOverlay', false);
        this.EditDialog = false;
        await this.getUserlist();
        this.resetInfoTitle = 'Password Berhasil Direset';
        this.resetInfoText = this.credentialText(
          this.editedItem.name,
          this.editedItem.email,
          'Password akun Satu-KPI Anda telah direset. Silakan login dengan:',
          res.data.password
        );
        this.resetInfoDialog = true;
      } catch (err) {
        this.$store.dispatch('setOverlay', false);
        this.snackbar = {
          color: "error",
          icon: "mdi-alert-circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          title: "Error",
          text: err.response?.data?.message || 'Failed to Reset Users !',
          visible: true
        };
      }
      this.closeEdit()
},

deleteItem(item) {
  this.editedItem = item;
  this.deleteDialog = true;
},

closeEdit() {
  this.editDialog = false
  this.resetpassDialog = false
},

roleChip(role) {
  const map = {
    super_admin: { label: 'Super Admin', icon: 'mdi-shield-crown', color: 'deep-purple lighten-5', textColor: 'deep-purple darken-2' },
    admin:       { label: 'Admin',       icon: 'mdi-shield-account', color: 'indigo lighten-5', textColor: 'indigo darken-2' },
    user:        { label: 'User',        icon: 'mdi-account', color: 'teal lighten-5', textColor: 'teal darken-2' },
  };
  return map[role] || { label: role, icon: 'mdi-account-question', color: 'grey lighten-3', textColor: 'grey darken-2' };
},

formatLastLogin(value) {
  if (!value) return '-';
  return new Date(value).toLocaleString('id-ID', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
},

copyResetInfo() {
  navigator.clipboard.writeText(this.resetInfoText).then(() => {
    this.snackbar = {
      color: "success",
      icon: "mdi-check-circle",
      mode: "multi-line",
      position: "top",
      timeout: 3000,
      title: "Copied",
      text: "Informasi login tersalin ke clipboard.",
      visible: true
    };
  });
},

async registerUser() {
  this.loadingRegister = true;
  this.$store.dispatch('setOverlay', true);
  const formData = new FormData();
  formData.append('name', this.newUser.username);
  formData.append('email', this.newUser.email);
  formData.append('role', this.newUser.role);
  formData.append('phone', this.newUser.phone);
  formData.append('entity_id', this.entity?.id);

  try {
    await this.$axios.post(
      `${process.env.VUE_APP_URL}/api/register`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    this.$store.dispatch('setOverlay', false);
    this.loadingRegister = false;
    this.showRegisterDialog = false;
    await this.getUserlist();
    this.resetInfoTitle = 'User Berhasil Didaftarkan';
    this.resetInfoText = this.credentialText(
      this.newUser.username,
      this.newUser.email,
      'Akun Satu-KPI Anda telah dibuat. Silakan login dengan:'
    );
    this.resetInfoDialog = true;
    this.$refs.form.reset();

  } catch (error) {
    this.loadingRegister = false;
    this.$store.dispatch('setOverlay', false);
    const data = error.response?.data;
    const message = data?.errors
      ? Object.values(data.errors).flat().join('\n')
      : (data?.message || 'Gagal register user.');
    this.snackbar = {
      color: "error",
      icon: "mdi-alert-circle",
      mode: "multi-line",
      position: "top",
      timeout: 7500,
      title: "Error",
      text: message,
      visible: true
    };
  }
},

// ponytail: default 'password123' harus sama dengan default register di backend
credentialText(name, email, intro, password = 'password123') {
  return [
    `Halo ${name},`,
    '',
    intro,
    '',
    `URL      : ${window.location.origin}`,
    `Email    : ${email}`,
    `Password : ${password}`,
    '',
    'Segera ganti password setelah login.',
  ].join('\n');
},

async getUserlistBySelfEntity() {
    if (!this.$store.getters.isTokenUser) return;
    try {
      const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.isTokenUser}`
        },
        params: {
          entity_id: this.entity.id
        }
      });

      this.datas = res.data.users;
      } catch (err) {
      // console.error("❌ Admin gagal load userlist:", err);
      }
},

async getUserlist() {
  if (!this.$store.getters.isTokenUser) return;

  const isSuperAdmin = this.user?.role === 'super_admin';

  try {
    const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/users`, {
      headers: {
        Authorization: `Bearer ${this.$store.getters.isTokenUser}`
      },
      ...(isSuperAdmin && this.entity?.id
        ? { params: { entity_id: this.entity.id } }
        : {})
    });
    const users = res.data.users; 
    this.roles = [...new Set(users.map(user => user.role))];
    this.datas = users.map(user => ({
      ...user,
      entity_name: user.entity?.name ?? '-',
      phone_entity: user.entity?.phone ?? '-',
      address_entity: user.entity?.address ?? '-',
      role: user.role,
    }));
  } catch (err) {
    console.error("❌ Gagal ambil userlist:", err.response?.data?.message || err);
  }
},

showStatusDialog(item) {
    this.selectedItem = {
      ...item,
      profile_img_url: item?.image
        ? `${process.env.VUE_APP_URL}/storage/${item.image}`
        : null
    };
    this.statusDialog = true;
},

async updateStatus(selectedItem){
if (selectedItem.chart_id === null) {
 this.snackbar = {
      color: 'error',
      mode: 'snackbar',
      position: "top",
      text: `User Ini Belum Masuk Kedalam Struktur Organisasi !`,
      timeout: 7500,
      title: null,
      visible: true,
      icon: 'mdi-alert-circle-outline',
    };
    return;
  }
this.$store.dispatch('setOverlay', true)
try {
    const payload = {
    status: selectedItem.status_publish,
    chart_id: selectedItem.chart_id
  };
  await new Promise(resolve => setTimeout(resolve, 1000));
  await this.$axios.post(`${process.env.VUE_APP_URL}/api/charts/status`,payload, {
    headers: {
      Authorization: `Bearer ${this.$store.getters.isTokenUser}`
    }
  });
  this.snackbar = {
      color: 'success',
      mode: 'snackbar',
      position: "top",
      text: '✅ Status Berhasil Di Update',
      timeout: 1500,
      title: null,
      visible: true
    };
  this.$store.dispatch('setOverlay', false)
  this.statusDialog = false;
  await this.getUserlist(); 
} catch (err) {
  this.$store.dispatch('setOverlay', false)
  this.statusDialog = false;
  console.error("❌ Gagal update status:", err.response?.data?.message || err);
}
},

async confirmDelete() {
  this.$store.dispatch('setOverlay', true)
  try {
    await this.$axios.delete(`${process.env.VUE_APP_URL}/api/user/${this.editedItem.id}`, {
      headers: {
        Authorization: `Bearer ${this.$store.getters.isTokenUser}`
      }
    });
    this.$store.dispatch('setOverlay', false)
    this.deleteDialog = false;
    await this.getUserlist(); 

  this.snackbar = {
        color: "success",
        icon: "mdi-account-check",
        mode: "multi-line",
        position: "top",
        timeout: 3000,
        title: "Success",
        text: "User Delete Successfully !",
        visible: true
      };
  } catch (err) {
    this.snackbar = {
      color: "error",
      icon: "mdi-alert",
      title: "Error",
      text: err.response?.data?.message || "Delete failed.",
      visible: true
    };
  }
},

exportExcel(){
  this.UploadDialog = true;
},

downloadTemplate() {
    this.downloadingTemplate = true;
    const url = 'https://api-kpi.j99corp.com/template/template_upload_user.xlsx';
    try {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.download = 'template_upload_user.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } finally {
      this.downloadingTemplate = false;
      this.$store.dispatch('setOverlay', false)
    }
},

onExcelSelected(file) {
      this.excelFile = Array.isArray(file) ? file[0] : file;
      this.uploadResult = null;
},

async uploadExcel() {
    if (!this.excelFile) return;
    this.uploadingExcel = true;
    this.uploadResult = null;

    try {
      this.$store.dispatch('setOverlay', true)
      const form = new FormData();
      form.append('users_file', this.excelFile);
      await new Promise(resolve => setTimeout(resolve, 1000));
      const url = `${(process.env.VUE_APP_URL || '').replace(/\/$/, '')}/api/users/batch-register`;
      const res = await this.$axios.post(url, form, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const data = res.data || {};
      const failures = Array.isArray(data.failures) ? data.failures : [];
      const failCount = failures.length;

      const message =
        failCount === 0
          ? (data.message || '✅ Import users berhasil.')
          : `${data.message || 'Batch import telah diproses.'} ${failCount} baris gagal.`;

      this.uploadResult = {
        ok: failCount === 0,
        message,
        failures
      };

      this.excelFile = null;
      await this.getUserlist();
    } catch (err) {
      this.$store.dispatch('setOverlay', false)
      const failures = err.response?.data?.failures || [];
      const msg =
        err.response?.data?.message ||
        err.message ||
        '❌ Gagal mengunggah file.';
      this.uploadResult = { ok: false, message: msg, failures };
    } finally {
      this.$store.dispatch('setOverlay', false)
      this.uploadingExcel = false;
    }
  },

closeUploadDialog() {
      this.UploadDialog = false;
      this.excelFile = null;
      this.uploadResult = null;
      this.uploadingExcel = false;
      this.downloadingTemplate = false;
},
}
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.v-btn {
  text-transform: none;
}

.v-data-table th {
  background-color: #003871 !important;
  color: white !important;
}

.search-field {
  max-width: 300px;
}
.upload-failure-divider {
  border-top: 1px solid #eee;
}
</style>